import { api, CustomAxiosRequestConfig } from "@/shared/api/client";
import { PageToolGetDTO } from "@/shared/types/inventory/tool";
import { DEFAULT_PAGE_SIZE } from "@/shared/config/pagination";

export const toolService = {
    getAll: async (page = 0, size = DEFAULT_PAGE_SIZE, filter?: { name?: string; value?: string; supplierId?: string }): Promise<PageToolGetDTO> => {
        const response = await api.get<unknown>("/offers/tools", {
            params: {
                page,
                size,
                ...filter
            },
        });

        // Handle raw arrays and paginated objects
        if (Array.isArray(response.data)) {
            return {
                content: response.data,
                empty: response.data.length === 0,
                first: true,
                last: true,
                number: 0,
                numberOfElements: response.data.length,
                pageable: {
                    offset: 0,
                    pageNumber: 0,
                    pageSize: size,
                    paged: false,
                    unpaged: true,
                    sort: { empty: true, sorted: false, unsorted: true }
                },
                size: response.data.length,
                sort: { empty: true, sorted: false, unsorted: true },
                totalElements: response.data.length,
                totalPages: 1,
            };
        }

        return response.data as PageToolGetDTO;
    },

    delete: async (id: string) => {
        await api.delete(`/offers/${id}`);
    },
};
